import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { QuizAIBaseComponent } from '../base.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';


@Component({
  selector: 'app-quiz-ai-modal',
  templateUrl: './quiz-ai-modal.component.html',
  styleUrls: ['./quiz-ai-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatTooltipModule,
    TranslatePipe
  ]
})

export class QuizAIModalComponent extends QuizAIBaseComponent {

}
